<div class="content-infos-globales">
  <span class="title-infos-globals">INFORMATIONS GLOBALES</span>
  <div class="promotion-grid ">
    <!-- Colonne 1 -->
    <div class="promotion-column">
      <div class="promotion-item">
        <span>Laboratoire : </span> {{ promotionInfo?.nomLaboratoire }}
      </div>
      <div class="promotion-item"><span>Libellé Promo : </span> {{ promotionInfo?.libellePromo }}</div>
      <div class="promotion-item">
        <span>Période : </span> {{ promotionInfo?.dateDebut | date : 'dd/MM/yyyy' }} -
        {{ promotionInfo?.dateFin | date : 'dd/MM/yyyy' }}
      </div>
      <div class="promotion-item"><span>Gamme : </span> {{ promotionInfo?.nomGamme }}</div>
    </div>

    <!-- Colonne 2 -->
    <div class="promotion-column">
      <div class="promotion-item">
        <span>Condition de Sell-In : </span> {{ promotionInfo?.conditionSellIn }}
      </div>
      <div class="promotion-item"><span>Offre : </span>{{ promotionInfo?.offre }}</div>
    </div>

    <!-- Colonne 3 -->
    <div class="promotion-column">
      <div class="promotion-item">
        <span>Total Quantité : </span> {{ promotionInfo?.quantiteVendue }}
      </div>
      <div class="promotion-item">
        <span>Total Sell-Out : </span>
        {{
          (promotionInfo?.montantVendu | customNumberFormat)
        }}
        &nbsp;€
      </div>
    </div>

    <!-- Colonne 4 -->
    <div class="promotion-column">
      <div class="promotion-item">
        <span>Mode de Compensation : </span> {{ promotionInfo?.modeCompensation }}
      </div>
      <div class="promotion-item">
        <span>Type de Compensation : </span> {{ promotionInfo?.typeCompensation }}
      </div>
      <div class="promotion-item">
        <span>Montant des Compensations Calculées : </span>
        {{
          (
            promotionInfo?.montantCompensationCalculee | customNumberFormat)
        }}
        &nbsp;€
      </div>
    </div>
  </div>
</div>
